"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const paths = () => [React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenOdd",
  d: "M9 2.75C5.54822 2.75 2.75 5.54822 2.75 9C2.75 12.4518 5.54822 15.25 9 15.25C12.4518 15.25 15.25 12.4518 15.25 9C15.25 5.54822 12.4518 2.75 9 2.75ZM1.25 9C1.25 4.71979 4.71979 1.25 9 1.25C13.2802 1.25 16.75 4.71979 16.75 9C16.75 13.2802 13.2802 16.75 9 16.75C4.71979 16.75 1.25 13.2802 1.25 9Z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenOdd",
  d: "M8.25 12.5V8H9.75V12.5H8.25Z"
}), React.createElement("path", {
  d: "M9.75 6.25C9.75 6.66421 9.41421 7 9 7C8.58579 7 8.25 6.66421 8.25 6.25C8.25 5.83579 8.58579 5.5 9 5.5C9.41421 5.5 9.75 5.83579 9.75 6.25Z"
})];
const InformationCircleSmall = _ref => {
  let {
    prefix
  } = _ref;
  return React.createElement(_ssrIcon.default, {
    className: `${prefix}price-module__small-icon`,
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    paths: paths
  });
};
InformationCircleSmall.defaultProps = {
  prefix: ''
};
var _default = InformationCircleSmall;
exports.default = _default;